import { useEffect, useState } from 'react';
import { 
  getWaMx, 
  getWaCo, 
  getWaUs, 
  getWaEs, 
  initializeRemoteConfig 
} from 'src/api/remoteConfig';

export interface WhatsAppNumbers {
  mx: string;
  co: string;
  us: string;
  es: string;
}

/**
 * Custom hook to fetch WhatsApp numbers from Firebase Remote Config
 * @returns Object with WhatsApp numbers for different countries and loading/error state
 */
export const useWhatsAppNumbers = () => {
  const [numbers, setNumbers] = useState<WhatsAppNumbers | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNumbers = async () => {
      try {
        setLoading(true);
        // Initialize Remote Config if not already done
        await initializeRemoteConfig();

        // Get WhatsApp numbers from Remote Config
        const waMx = getWaMx();
        const waCo = getWaCo();
        const waUs = getWaUs();
        const waEs = getWaEs();

        setNumbers({
          mx: waMx,
          co: waCo,
          us: waUs,
          es: waEs,
        });

        setError(null);
      } catch (err) {
        console.error('Error fetching WhatsApp numbers:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
        setNumbers(null);
      } finally {
        setLoading(false);
      }
    };

    fetchNumbers();
  }, []);

  return { numbers, loading, error };
};
